import { render, staticRenderFns } from "./Mails.vue?vue&type=template&id=8bc5e5c6&scoped=true"
import script from "./Mails.vue?vue&type=script&lang=js"
export * from "./Mails.vue?vue&type=script&lang=js"
import style0 from "./Mails.vue?vue&type=style&index=0&id=8bc5e5c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc5e5c6",
  null
  
)

export default component.exports